import { css } from "@emotion/react";
import styled from "@emotion/styled";

export const StylePaginationWrapper = styled.div<{ $visible?: boolean }>`
  display: ${(props: any) => (props.$visible ? "flex" : "none")};
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
  border-top: 1px solid
    ${(props: any) => props.theme.colors.border || "#e1e5e9"};
  margin-top: 24px;
  font-family:
    -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 16px;
    padding: 16px 0;
  }
`;

export const StyleCountWrapper = styled.p`
  color: ${(props: any) => props.theme.colors.textSecondary || "#6b7280"};
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.25px;
  line-height: 20px;
  margin: 0;
`;

export const StylePaginationButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const StylePaginationButton = styled.button<{
  $active?: boolean;
  $variant?: "number" | "nav";
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: ${(props: any) => (props.$variant === "number" ? "40px" : "auto")};
  height: 40px;
  padding: ${(props: any) =>
    props.$variant === "number" ? "0 12px" : "8px 16px"};
  border: 1px solid;
  border-color: ${(props: any) => props.theme.colors.border || "#e1e5e9"};
  border-radius: 8px;
  background-color: ${(props: any) => {
    if (props.$active) return props.theme.orange.orange500 || "#f97316";
    if (props.$variant === "nav") return "transparent";
    return "#ffffff";
  }};
  color: ${(props: any) => {
    if (props.$active) return "#ffffff";
    return props.theme.colors.text || "#374151";
  }};
  font-size: 14px;
  font-weight: ${(props: any) => (props.$active ? "600" : "400")};
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  position: relative;
  overflow: hidden;

  &:hover:not(:disabled) {
    background-color: ${(props: any) => {
      if (props.$active) return props.theme.orange.orange600 || "#ea580c";
      return props.theme.orange.orange50 || "#fff7ed";
    }};
    border-color: ${(props: any) => {
      if (props.$active) return props.theme.orange.orange600 || "#ea580c";
      return props.theme.orange.orange300 || "#fdba74";
    }};
    color: ${(props: any) => {
      if (!props.$active && props.$variant === "nav")
        return props.theme.orange.orange600 || "#ea580c";
      return props.$active
        ? "#ffffff"
        : props.theme.orange.orange700 || "#c2410c";
    }};
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
    box-shadow: none;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;

    &:hover {
      background-color: ${(props: any) => {
        if (props.$active) return props.theme.orange.orange500 || "#f97316";
        return "#ffffff";
      }};
      border-color: ${(props: any) => props.theme.colors.border || "#e1e5e9"};
      color: ${(props: any) => {
        if (props.$active) return "#ffffff";
        return props.theme.colors.text || "#374151";
      }};
    }
  }

  ${(props: any) =>
    props.$variant === "nav" &&
    css`
      font-weight: 500;
      gap: 6px;

      &:hover:not(:disabled) {
        background-color: ${props.theme.orange.orange50 || "#fff7ed"};
        color: ${props.theme.orange.orange600 || "#ea580c"};
        border-color: ${props.theme.orange.orange300 || "#fdba74"};
      }
    `}

  @media (max-width: 480px) {
    min-width: ${(props: any) =>
      props.$variant === "number" ? "36px" : "auto"};
    height: 36px;
    padding: ${(props: any) =>
      props.$variant === "number" ? "0 8px" : "6px 12px"};
    font-size: 13px;
  }
`;

export const StylePaginationEllipsis = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  height: 40px;
  color: ${(props: any) => props.theme.colors.textSecondary || "#6b7280"};
  font-size: 14px;
  font-weight: 400;

  @media (max-width: 480px) {
    min-width: 36px;
    height: 36px;
  }
`;

export const StylePaginationNavText = styled.span`
  @media (max-width: 480px) {
    display: none;
  }
`;
